/* eslint-disable max-classes-per-file */

import { RequestListProductTypeEnums } from "@/types/product/account/history";
import { imageFallback } from "@/utils/error/imageError";

import { ResponsePresenter } from "../../common/commonClassPresenter";
import {
  ContactDatePresenter,
  DayPlanDataPresenter,
  ListStepDataPresenter,
  RePaymentPresenter,
} from "./historyBookingCommonInterface";

export class EventGuestPresenter {
  title: string;

  firstName: string;

  lastName: string;

  birthday: string;

  countryOfPassport: string;

  passportNumber: string;

  constructor(response: any) {
    this.title = response?.title || "";
    this.firstName = response?.firstName || "";
    this.lastName = response?.lastName || "";
    this.birthday = response?.birthday || "";
    this.countryOfPassport = response?.countryOfPassport || "";
    this.passportNumber = response?.passportNumber || "";
  }
}

export class EventLocationPresenter {
  name: string;

  countryName: string;

  countrySlug: string;

  cityName: string;

  citySlug: string;

  areaName: string;

  areaSlug: string;

  latitude: number;

  longitude: number;

  addressFull: string;

  constructor(response: any) {
    this.name = response?.name || "";
    this.countryName = response?.countryName || "";
    this.countrySlug = response?.countrySlug || "";
    this.cityName = response?.cityName || "";
    this.citySlug = response?.citySlug || "";
    this.areaName = response?.areaName || "";
    this.areaSlug = response?.areaSlug || "";
    this.latitude = response?.latitude || 0;
    this.longitude = response?.longitude || 0;
    this.addressFull = response?.addressFull || "";
  }
}

export class EventListDataPresenter {
  type: string;

  rsvnId: string;

  reservationNo: string;

  bookingInternalNo: string;

  pinCode: string;

  numberOfCard: number;

  seatName: string;

  paymentStatus: string;

  bookingStatus: string;

  joinDateOri: string;

  joinDate: string;

  dateCancelOri: string;

  dateCancel: string;

  name: string;

  seat: string;

  banner: string;

  image: string;

  bookingDateOri: string;

  bookingDate: string;

  ticketCategoryMainType: string;

  bookForOther: string;

  freeCancellation: boolean;

  dayPlan: DayPlanDataPresenter;

  payment: RePaymentPresenter;

  contact: ContactDatePresenter;

  guest: EventGuestPresenter;

  location: EventLocationPresenter;

  productType: string;

  price: number;

  currency: string;

  // cancellationPolicy: any
  constructor(response: any) {
    this.type = response?.type || "";
    this.rsvnId = response?.rsvnId || "";
    this.reservationNo = response?.reservationNo || "";
    this.bookingInternalNo = response?.bookingInternalNo || "";
    this.pinCode = response?.pinCode || "";
    this.numberOfCard = response?.numberOfCard || 0;
    this.seatName = response?.seatName || "";
    this.paymentStatus = (response?.paymentStatus || "").toLocaleLowerCase();
    this.bookingStatus = (response?.bookingStatus || "").toLocaleLowerCase();
    this.joinDateOri = response?.joinDateOri || "";
    this.joinDate = response?.joinDate || "";
    this.dateCancelOri = response?.dateCancelOri || "";
    this.dateCancel = response?.dateCancel || "";
    this.name = response?.name || "";
    this.seat = response?.seat || "";
    this.banner = response?.banner || imageFallback;
    this.image = response?.image || imageFallback;
    this.bookingDateOri = response?.bookingDateOri || "";
    this.bookingDate = response?.bookingDate || "";
    this.ticketCategoryMainType = response?.ticketCategoryMainType || "";
    this.bookForOther = response?.bookForOther || "";
    this.freeCancellation = response?.freeCancellation || false;
    this.dayPlan = new DayPlanDataPresenter(response?.dayPlan);
    this.payment = new RePaymentPresenter(response?.payment);
    this.contact = new ContactDatePresenter(response?.contact);
    this.guest = new EventGuestPresenter(response?.guest);
    this.location = new EventLocationPresenter(response?.location);
    this.productType = RequestListProductTypeEnums.EVENT;
    this.price = response?.price || 0;
    this.currency = response?.currency || "";
  }
}

export class EventListStepData extends ListStepDataPresenter<
  EventListDataPresenter[]
> {
  constructor(response: any) {
    super(response, (data) =>
      (data || []).map((val: any) => new EventListDataPresenter(val)),
    );
  }
}
export class ResponseGetHistoryEventListPresenter extends ResponsePresenter<
  EventListStepData[]
> {
  constructor(response: any) {
    super(response, (data) =>
      (data || []).map((val: any) => new EventListStepData(val)),
    );
  }
}
